<template>
    <div>
<!--        <strong>{{ getActorName() }}</strong>-->
<!--        joined to chat with-->
<!--        <strong>{{ $_.get(activity, "payload.fullname") }} </strong>-->
        <span v-html="$t('notification.chatJoined', {agent: getActorName(), visitor: $_.get(activity, 'payload.fullname') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatJoined",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getActorName() {
            if (this.activity.actor === "user") {
                return this.$_.get(this.activity, "actorUser.name");
            } else if (this.activity.actor === "visitor") {
                return this.$_.get(this.activity, "refVisitor.fullname");
            } else if (this.activity.actor === "chatbot") {
                return "Chatbot";
            } else if (this.activity.actor === "system") {
                return "System";
            }
        },
    },
});
</script>

<style scoped lang="scss"></style>
